<template>
  <div class="offcanvas-body">
    <p class="text-paragraph">
      Adicione um vídeo seu do Youtube contando um pouco da sua experiência como
      profissional.
    </p>
    <YoutubeInput
      label="Link do Youtube"
      :value="session?.formatted_intro_video_link"
      :model="introVideoLinkModel"
    />
    <FormButton
      label="Concluir"
      :loading="submitting"
      :disabled="!meta.valid"
      @onClick="submit"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { introVideoSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { handleSubmit, meta } = useForm({
  validationSchema: toTypedSchema(introVideoSchema),
  initialValues: { intro_video_link: "" },
});

const introVideoLinkModel = useVeeField("intro_video_link");
const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    const intro_video_link = values.intro_video_link.split("embed/")[1];
    await updateUser({ id: session.value!.id, intro_video_link });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
